import { render, staticRenderFns } from "./MoveItemTo.vue?vue&type=template&id=519862e1&scoped=true&"
import script from "./MoveItemTo.vue?vue&type=script&lang=js&"
export * from "./MoveItemTo.vue?vue&type=script&lang=js&"
import style0 from "./MoveItemTo.vue?vue&type=style&index=0&id=519862e1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519862e1",
  null
  
)

export default component.exports